// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "kiosk" + "." + "2c6580c59c08e1e9f0d5" + ".css";
};